import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-10" }
const _hoisted_2 = { class: "flex flex-col items-start justify-between gap-4 mt-6 space-y-3 md:flex-row md:space-y-0" }
const _hoisted_3 = { class: "grid gap-4 mb-4 md:gap-6 md:grid-cols-2 sm:mb-8" }
const _hoisted_4 = {
  class: "inline-flex relative items-center cursor-pointer",
  for: "setup-completed"
}
const _hoisted_5 = {
  class: "inline-flex relative items-center cursor-pointer",
  for: "user-status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[28] || (_cache[28] = _createStaticVNode("<nav aria-label=\"Breadcrumb\" class=\"flex\"><ol class=\"inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse\"><li class=\"inline-flex items-center\"><a class=\"inline-flex items-center text-sm font-medium text-gray-700 hover:text-primary dark:text-gray-400 dark:hover:text-white\" href=\"#\"> Admin </a></li><li><div class=\"flex items-center\"><svg aria-hidden=\"true\" class=\"w-3 h-3 mx-1 text-gray-400 rtl:rotate-180\" fill=\"none\" viewBox=\"0 0 6 10\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m1 9 4-4-4-4\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"></path></svg><a class=\"text-sm font-medium text-black ms-1 hover:text-primary md:ms-2 dark:text-white dark:hover:text-white\" href=\"#\">Users</a></div></li></ol></nav>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "w-full",
        onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateUser && _ctx.updateUser(...args)), ["prevent"]))
      }, [
        _cache[26] || (_cache[26] = _createElementVNode("h2", { class: "mb-4 text-xl font-semibold leading-none text-gray-900 dark:text-white" }, " General Information ", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _cache[10] || (_cache[10] = _createElementVNode("label", {
              class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
              for: "first-name"
            }, "Full Name", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "first-name",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.fullName) = $event)),
              class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500",
              name: "first-name",
              placeholder: "Ex. John",
              type: "text"
            }, null, 512), [
              [_vModelText, _ctx.user.fullName]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[11] || (_cache[11] = _createElementVNode("label", {
              class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
              for: "company"
            }, "Company", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "company",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.company) = $event)),
              class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500",
              name: "company",
              placeholder: "Ex. Nevcap Ventures",
              type: "text"
            }, null, 512), [
              [_vModelText, _ctx.user.company]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[12] || (_cache[12] = _createElementVNode("label", {
              class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
              for: "email"
            }, "Email", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "email",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.email) = $event)),
              class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500",
              name: "email",
              placeholder: "Ex. name@company.com",
              required: "",
              type: "email",
              value: "helene@company.com"
            }, null, 512), [
              [_vModelText, _ctx.user.email]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[14] || (_cache[14] = _createElementVNode("label", {
              class: "inline-flex items-center mb-2 text-sm font-medium text-gray-900 dark:text-white",
              for: "membership-plan"
            }, " Membership Plan ", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "membership-plan",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.membershipPlan) = $event)),
              class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
            }, _cache[13] || (_cache[13] = [
              _createElementVNode("option", { value: "community" }, " Community ", -1),
              _createElementVNode("option", { value: "community_plus" }, " Community Plus ", -1)
            ]), 512), [
              [_vModelSelect, _ctx.user.membershipPlan]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "mb-2 text-sm font-medium text-gray-900 dark:text-white" }, " Setup Completed ", -1)),
            _createElementVNode("label", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                id: "setup-completed",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.setupCompleted) = $event)),
                class: "sr-only peer",
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, _ctx.user.setupCompleted]
              ]),
              _cache[15] || (_cache[15] = _createElementVNode("span", { class: "w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 dark:peer-focus:ring-primary-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-primary-600" }, null, -1)),
              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "ml-3 text-sm font-medium text-gray-500 dark:text-gray-300" }, "Completed", -1))
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[18] || (_cache[18] = _createElementVNode("label", {
              class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
              for: "phoneNumber"
            }, "Phone Number", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "phoneNumber",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user.phoneNumber) = $event)),
              class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500",
              name: "phoneNumber",
              placeholder: "Ex. +44 20 1234 5678",
              type: "text"
            }, null, 512), [
              [_vModelText, _ctx.user.phoneNumber]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[20] || (_cache[20] = _createElementVNode("label", {
              class: "inline-flex items-center mb-2 text-sm font-medium text-gray-900 dark:text-white",
              for: "user-role"
            }, " User Role ", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "user-role",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.user.role) = $event)),
              class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
            }, _cache[19] || (_cache[19] = [
              _createElementVNode("option", { value: "admin" }, " Admin ", -1),
              _createElementVNode("option", { value: "user" }, " User ", -1)
            ]), 512), [
              [_vModelSelect, _ctx.user.role]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[22] || (_cache[22] = _createElementVNode("label", {
              class: "inline-flex items-center mb-2 text-sm font-medium text-gray-900 dark:text-white",
              for: "email-status"
            }, " Email Verification ", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "email-status",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.user.verified) = $event)),
              class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
            }, _cache[21] || (_cache[21] = [
              _createElementVNode("option", { value: "true" }, " Verified ", -1),
              _createElementVNode("option", { value: "false" }, " Unverified ", -1)
            ]), 512), [
              [_vModelSelect, _ctx.user.verified]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "mb-2 text-sm font-medium text-gray-900 dark:text-white" }, " Account Status ", -1)),
            _createElementVNode("label", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                id: "user-status",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.user.isActive) = $event)),
                class: "sr-only peer",
                type: "checkbox",
                value: ""
              }, null, 512), [
                [_vModelCheckbox, _ctx.user.isActive]
              ]),
              _cache[23] || (_cache[23] = _createElementVNode("span", { class: "w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 dark:peer-focus:ring-primary-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-primary-600" }, null, -1)),
              _cache[24] || (_cache[24] = _createElementVNode("span", { class: "ml-3 text-sm font-medium text-gray-500 dark:text-gray-300" }, "Active", -1))
            ])
          ])
        ]),
        _cache[27] || (_cache[27] = _createElementVNode("button", {
          class: "inline-flex items-center px-5 py-3 text-sm font-medium text-center text-white bg-black rounded-lg hover:bg-gray-800 focus:ring-4 focus:outline-none focus:ring-gray-300 dark:bg-gray-600 dark:hover:bg-gray-700 dark:focus:ring-gray-800",
          type: "submit"
        }, " Update User ", -1))
      ], 32)
    ])
  ]))
}